export const indexSelector = state => state.predictor.step.index;
export const valueSelector = state => state.predictor.values;
